import React from "react"
import Navbar from "../../../../Common/Components/Navbar"
import Footer from "../../../../Common/Components/Footer"
import AssignmentPreviewAndAttendComp from "./Component/AssignmentPreviewAndAttendComp"
import Sidebar from "../../../../Sidebar/Sidebar"

const AssignmentPreviewAndAttend =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
             <AssignmentPreviewAndAttendComp/>
        </div>
        <Footer />
        </>
    )
}

export default AssignmentPreviewAndAttend;